import { debounce } from 'throttle-debounce';

export function scrollToTopWithCallback(onScrollEnds: VoidFunction): void {
  const { top } = document.body.getBoundingClientRect();

  if (top === 0) {
    onScrollEnds();

    return;
  }

  const handler = debounce(50, () => {
    onScrollEnds();

    document.removeEventListener('scroll', handler);
  });

  document.addEventListener('scroll', handler);

  window.scrollTo({ behavior: 'smooth', top: 0 });
}
